import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../../../Button'
import { QA_NAME_OVERVIEW_ATTENTION_VIEW } from '../RentalPortalOverviewAttentionRow.constants'

function OverviewAttentionViewAction({ onMouseDownView, onOpenView }) {
  const { t } = useTranslation()

  return (
    <Button.Outlined
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_OVERVIEW_ATTENTION_VIEW}
      text={t('RentalPortal.OverviewActionViewKey')}
      onClick={onOpenView}
      onMouseDown={onMouseDownView}
    />
  )
}

export default OverviewAttentionViewAction
